import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { InputSharedModule } from '../../molecules/input/input.module';
import { InputCalendarSharedComponent } from './input.calendar.component';
import { DatepickerSharedModule } from '../../molecules/datepicker/datepicker.module';

@NgModule({
    declarations: [
        InputCalendarSharedComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        InputSharedModule,
        DatepickerSharedModule
    ],
    exports: [
        InputCalendarSharedComponent
    ]
})

export class InputCalendarSharedModule {}
